import script from "./clientsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./clientsForm.vue?vue&type=script&setup=true&lang=js"

import "./clientsForm.vue?vue&type=style&index=0&id=abd86418&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abd86418"]])

export default __exports__